// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"273":"component---src-pages-404-index-ts","351":"commons","532":"styles","756":"component---src-pages-index-ts"}[chunkId] + "-" + {"273":"94b8b0c3de75cb0b8f01","351":"96ae8f2a3b07fd1fc60a","532":"fe0c0cb1e11e2a6d17d2","756":"31646ae03c25a48dbb2f"}[chunkId] + ".js";
};